<template>
  <v-scale-transition>
    <kits-panel
      :kits-items="royaltyIncentiveKits"
      :breadcrumbs="breadcrumbs"
    >
      <h3 class="headline grey--text text-xs-center hidden-sm-and-down">
        {{ title }}
      </h3>
    </kits-panel>
  </v-scale-transition>
</template>

<script>
const title = 'RI'

export default {
  components: {
    KitsPanel: () => import(/* webpackChunkName: "kitsPanel" */ '@/components/KitsPanel'),
  },
  data () {
    return {
      breadcrumbs: [
        {
          text: 'Incentives', disabled: false, to: '/incentives',
        },
        {
          text: title, disabled: true,
        },
      ],
      royaltyIncentiveKits: [
        {
          icon: 'mdi-calendar-blank-multiple',
          path: '/annual_royalty_incentive',
          title: 'Annual Summary',
          desc: 'Annual royalty incentive summary.',
        },
        {
          icon: 'mdi-calendar-blank',
          path: '/monthly_royalty_incentive',
          title: 'Monthly Summary',
          desc: 'Monthly royalty incentive summary.',
        },
        {
          icon: 'mdi-calendar-text',
          path: '/daily_royalty_incentive',
          title: 'Daily Details',
          desc: 'Daily details of reloads.',
        },
        {
          icon: 'mdi-calendar-account',
          path: '/subscriber_reload',
          title: 'Subscriber Summary',
          desc: 'Breakdown of reloads by subscriber.',
        },
      ],
      title,
    }
  },
}
</script>
